import _ from 'lodash';

import abstractRes from '../abstract.resource';
import {readUser, writeUser} from '../serializers/user.serializer';

const LOGIN_PATH = '/login/';

const LOGOUT_PATH = '/logout/';

const mod = angular.module('app.common.resources.user', [abstractRes])

.factory('UserResource', function ($http, $log, AbstractResource) {
  class UserResource extends AbstractResource {
    constructor() {
      super('users', UserResource.fromBackend, false);
    }

    getMany(...args) { // eslint-disable-line no-unused-vars
      throw new Error('Not applicable for UserResource.');
    }

    /**
     * Get the currently active user.
     *
     * @param {boolean} extra_data Set to true to fetch extra data from Podio.
     * @returns {Promise.<User>} Promise that resolves with the user model or rejects if user is not authenticated.
     */
    get(extra_data=false) {
      return this.getOne('me', undefined, {extra_data});
    }

    getChatSecureData() {
      return $http.get(this.url + 'chat_secure_data/')
        .then(response => {
          return response.data
        })
        .catch((err) => {
          $log.debug('Error while getting chat secure metadata, IGNORED', err)
          return null
        })
    }

    /**
     * Update the given user's data on the backend.
     * @param {User} user
     * @returns {Promise.<User>} Promise that resolves with the updated user model if update was successful and rejects
     *   if not.
     */
    update(user) {
      return $http.post(this.url + 'me/', writeUser(user), {headers: this._headers}).then(response => {
        const copy = user.copy();
        _.assign(copy, UserResource.fromBackend(response.data));
        copy.makeImmutable();
        return copy;
      });
    }

    /**
     * Attempt to log in with the specified credentials.
     *
     * @param {string} username
     * @param {string} password
     * @returns {Promise.<User>} Resolves with user model or rejects if login is not accepted.
     */
    login(username, password) {
      return $http.post(this.base_url + LOGIN_PATH, {username, password}, {headers: this._headers})
      .then(response => UserResource.fromBackend(response.data));
    }

    /**
     * Log the user out of the system.
     * @return {Promise}
     */
    logout() {
      return $http.post(this.base_url + LOGOUT_PATH, {}, {headers: this._headers});
    }

    /**
     * Parse a user retrieved from the backend.
     * @param {Object} o
     * @returns {User}
     */
    static fromBackend(o) {
      return readUser(o).makeImmutable();
    }
  }

  return new UserResource();
});

export {LOGIN_PATH, LOGOUT_PATH};
export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/user.resource.js